// language=GraphQL
export const ALL_CONTACT_BLOCK_SETTINGS_QUERY = `query Query {
  contactBlockSettings: allCmsContactBlockSettings {
    id
    slogan
    title
    text
    phonePrefix
    phone
    phone2Prefix
    phone2
    openingHours1
    openingHours2
    email
  }
}`

// language=GraphQL
export const SINGLE_CONTACT_BLOCK_SETTINGS_QUERY = `query Query($id: ID!) {
  contactBlockSettings: cmsContactBlockSettings(id: $id) {
    id
    slogan
    title
    text
    phonePrefix
    phone
    phone2Prefix
    phone2
    openingHours1
    openingHours2
    email
  }
}`

// language=GraphQL
export const CREATE_CONTACT_BLOCK_SETTINGS_MUTATION = `
  mutation Mutation($input: CreateCmsContactBlockSettingsInput) {
    contactBlockSettings: createCmsContactBlockSettings(input: $input) {
      id
      slogan
      title
      text
      phonePrefix
      phone
      phone2Prefix
      phone2
      openingHours1
      openingHours2
      email
    }
  }`

// language=GraphQL
export const UPDATE_CONTACT_BLOCK_SETTINGS_MUTATION = `
  mutation Mutation($input: UpdateCmsContactBlockSettingsInput) {
    contactBlockSettings: updateCmsContactBlockSettings(input: $input) {
      id
      slogan
      title
      text
      phonePrefix
      phone
      phone2Prefix
      phone2
      openingHours1
      openingHours2
      email
    }
  }`

// language=GraphQL
export const DELETE_CONTACT_BLOCK_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteCmsContactBlockSettingsInput) {
    deleteCmsContactBlockSettings(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_CONTACT_BLOCK_SETTINGS_MUTATION = `
  mutation Mutation($input: DeleteCmsContactBlockSettingsInput) {
    forceDeleteCmsContactBlockSettings(input: $input) {
      success
    }
  }`
// language=GraphQL
export const CONTACT_BLOCK_SETTINGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withCmsConfigs: Boolean = false) {
  groupedDependents: cmsContactBlockSettingsDependents(id: $id) {
    cmsConfigs @include(if: $withCmsConfigs) {
      id
    }
  }
}`
